var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12267 3.68691H7.84964V11.5926C7.84964 11.6955 7.93377 11.7796 8.03659 11.7796H9.43873C9.54156 11.7796 9.62568 11.6955 9.62568 11.5926V3.68691H11.3573C11.5139 3.68691 11.6004 3.50697 11.5045 3.38545L8.88722 0.0717308C8.86974 0.0493859 8.84739 0.0313147 8.82188 0.0188867C8.79638 0.00645877 8.76837 0 8.74 0C8.71163 0 8.68362 0.00645877 8.65811 0.0188867C8.63261 0.0313147 8.61026 0.0493859 8.59278 0.0717308L5.97545 3.38312C5.87964 3.50697 5.9661 3.68691 6.12267 3.68691ZM17.293 10.8916H15.8909C15.7881 10.8916 15.704 10.9757 15.704 11.0785V14.6773H1.77604V11.0785C1.77604 10.9757 1.69191 10.8916 1.58909 10.8916H0.186952C0.0841283 10.8916 0 10.9757 0 11.0785V15.7056C0 16.1192 0.334176 16.4534 0.747807 16.4534H16.7322C17.1458 16.4534 17.48 16.1192 17.48 15.7056V11.0785C17.48 10.9757 17.3959 10.8916 17.293 10.8916Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.b9fdd7ba.svg";
export { ForwardRef as ReactComponent };